// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__futTH","tyre":"style_tyre__O1Y20"};